import styles from './FaqHero.module.css';

export default function FaqHero() {
  return (
    <section className={styles.hero}>
      <div className={styles.inner}>
        <span className={styles.eyebrow}>FAQ</span>
        <h1 className={styles.headline}>Questions, answered.</h1>
        <p className={styles.sub}>
          Straight answers on credits, data, and billing. If a question isn't here, ask us and
          we reply within one business day.
        </p>
      </div>
    </section>
  );
}
